import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.g4 = languageMap.antlr4 = bracketIndenting()
